import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinpatancheru() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Patancheru Hyderabad',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Patancheru Hyderabad',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Patancheru Hyderabad, catering to the transportation needs of industrial units, manufacturing plants, and corporate offices in the region. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, supervisors, clients, and senior executives. Whether it is daily staff commute, plant visits, airport transfers, inter-office travel, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Patancheru Hyderabad.',

    top: 'Top Places to Visit in Hyderabad with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Charminar",
    "description": "Charminar is Hyderabad’s most iconic landmark, built in 1591 by Sultan Muhammad Quli Qutb Shah. This grand square-shaped monument features four towering minarets and intricate Islamic architecture. Surrounded by bustling bazaars, street food vendors, and shops selling pearls, bangles, and traditional crafts, Charminar is a cultural and historical hub, attracting tourists from across India and the world."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort is a majestic fortress located on the outskirts of Hyderabad, known for its massive walls, impressive gateways, and acoustic marvels. Once the capital of the Qutb Shahi dynasty, it offers panoramic views of the city and nearby hills. The evening light and sound show narrates the fort’s rich history, making it a favorite destination for history enthusiasts and photographers."
  },
  {
    "title": "Hussain Sagar Lake",
    "description": "Hussain Sagar Lake is a large man-made lake in the heart of Hyderabad, famous for the gigantic Buddha statue standing on Gibraltar Rock in the middle of the water. The lake is popular for boating, evening walks, and lakeside leisure. Surrounded by parks, eateries, and promenades, it serves as a serene escape and recreational spot for locals and tourists."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Salar Jung Museum is one of India’s largest museums, housing an extensive collection of art, sculptures, manuscripts, and artifacts from India and around the world. Visitors can explore centuries of history and culture through exhibits such as Mughal miniatures, European paintings, and decorative arts. The museum provides an immersive educational experience for art and history enthusiasts."
  },
  {
    "title": "Ramoji Film City",
    "description": "Ramoji Film City is one of the world’s largest film studio complexes and a popular entertainment destination near Hyderabad. Spread across thousands of acres, it features film sets, amusement rides, gardens, and live shows. Visitors can enjoy guided tours, interactive experiences, and cultural performances, making it a top choice for family outings and film enthusiasts."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Chowmahalla Palace is a stunning 18th-century palace that once served as the seat of the Nizams of Hyderabad. The complex features grand halls, intricate interiors, beautiful courtyards, and royal artifacts. Visitors can explore the opulent architecture and learn about the history and lifestyle of the Nizams, making it a cultural and historical gem of the city."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir is a magnificent white marble temple dedicated to Lord Venkateswara, located on a hill overlooking Hyderabad. The temple offers panoramic views of the city and the lake below. Visitors can admire the detailed carvings, serene surroundings, and participate in spiritual rituals, making it a peaceful retreat in the heart of the city."
  },
  {
    "title": "Laad Bazaar",
    "description": "Laad Bazaar, located near Charminar, is Hyderabad’s famous shopping street, known for its vibrant bangles, jewelry, pearls, textiles, and handicrafts. The bustling markets and colorful storefronts create an authentic local experience. It is a must-visit for tourists looking to shop, explore, and enjoy the vibrant culture of the old city."
  },
  {
    "title": "Necklace Road",
    "description": "Necklace Road is a scenic boulevard along Hussain Sagar Lake, popular for evening walks, recreational activities, and lakeside dining. It features landscaped gardens, jogging tracks, and food stalls. The area is ideal for leisure, family outings, and enjoying the illuminated view of the Buddha statue on the lake."
  },
  {
    "title": "Qutb Shahi Tombs",
    "description": "The Qutb Shahi Tombs are the royal necropolis of the Qutb Shahi dynasty, located near Golconda Fort. The complex features grand domed tombs, landscaped gardens, and intricate stonework. Visitors can explore the historical architecture, learn about the dynasty’s legacy, and enjoy peaceful walks amidst the ancient structures."
  }
],


"services": [
  {
    "name": "Patancheru Industrial Cab",
    "description": "Patancheru Industrial Cab offers reliable corporate transportation solutions for employees, executives, and factory workers traveling to industrial zones in Patancheru. With a fleet of sedans, SUVs, and shuttle vans, it ensures safe, efficient, and timely pickups, flexible routes, and seamless coordination for factory and office staff commuting."
  },
  {
    "name": "Employee Shuttle Patancheru",
    "description": "Employee Shuttle Patancheru provides high-capacity shuttle services designed for companies with large staff movements. Featuring AC minibuses and optimized routes, it ensures timely and safe employee transport within Patancheru's industrial and commercial zones. The service supports multiple shifts, real-time tracking, and peak-hour travel."
  },
  {
    "name": "Business Cab Patancheru",
    "description": "Business Cab Patancheru delivers premium corporate travel solutions for business meetings, client visits, inter-office transfers, and executive mobility. With comfortable sedans and SUVs, experienced chauffeurs, and reliable dispatch services, it caters to professionals seeking a seamless and efficient travel experience."
  },
  {
    "name": "Affordable Cab Patancheru",
    "description": "Affordable Cab Patancheru offers budget-friendly corporate transportation services without compromising on safety, comfort, or reliability. Ideal for startups and mid-sized companies, it features efficient routing, clean vehicles, and professional drivers, making it a cost-effective solution for employee and executive commuting."
  },
  {
    "name": "Monthly Corporate Cab Patancheru",
    "description": "Monthly Corporate Cab Patancheru provides contract-based employee transportation solutions with dedicated vehicles, trained drivers, and GPS-enabled monitoring. It ensures consistent, uninterrupted commuting for employees, with predictable pricing and full fleet management to meet the needs of companies in Patancheru."
  },
  {
    "name": "Best Corporate Cab Patancheru",
    "description": "Best Corporate Cab Patancheru offers top-tier travel solutions with high-quality vehicles, expert chauffeurs, and stringent safety standards. Designed for executives, VIPs, and business travelers, it ensures a smooth and professional travel experience, including airport transfers, client visits, and inter-office mobility."
  },
  {
    "name": "Outstation Cab Patancheru",
    "description": "Outstation Cab Patancheru provides reliable long-distance corporate travel services for business trips, client visits, and executive travel. Featuring sedans and SUVs, experienced chauffeurs, and real-time tracking, it ensures safe and efficient outstation mobility for businesses in Patancheru."
  },
  {
    "name": "Sedan Cab Patancheru",
    "description": "Sedan Cab Patancheru offers executive sedans suitable for managerial commute, business meetings, and premium office travel. With well-maintained interiors, professional drivers, and a focus on comfort and punctuality, it ensures a refined and smooth travel experience for corporate employees."
  },
  {
    "name": "SUV Cab Patancheru",
    "description": "SUV Cab Patancheru provides spacious and high-performance SUVs, ideal for senior executives, team travel, and long-distance corporate trips. Equipped with safety features, GPS tracking, and trained chauffeurs, it ensures comfort, safety, and reliability for corporate clients."
  },
  {
    "name": "Company Fleet Patancheru",
    "description": "Company Fleet Patancheru offers end-to-end fleet management and outsourcing solutions, providing businesses with fully managed transportation. The service includes driver management, vehicle maintenance, route optimization, and compliance tracking, ensuring efficient, reliable, and scalable transport operations."
  },
  {
    "name": "Factory Worker Cab Patancheru",
    "description": "Factory Worker Cab Patancheru provides affordable and reliable transportation solutions for workers commuting to industrial areas in Patancheru. With scheduled pickups, dedicated routes, and professional drivers, it ensures timely and safe travel for large groups of workers."
  },
  {
    "name": "Office Transport Patancheru",
    "description": "Office Transport Patancheru offers tailored daily commuting services for employees working in office complexes and industrial hubs in Patancheru. The service includes pre-planned routes, real-time tracking, and professional chauffeurs, ensuring safe, efficient, and consistent employee transportation."
  },
  {
    "name": "Corporate Shuttle Patancheru",
    "description": "Corporate Shuttle Patancheru provides large-scale shuttle services with AC minibuses and efficient routing, designed for companies with a high volume of employees commuting to Patancheru. It supports multi-shift operations, real-time tracking, and optimized scheduling to ensure smooth and organized employee mobility."
  },
  {
    "name": "Employee Commute Patancheru",
    "description": "Employee Commute Patancheru offers structured, reliable daily transport for employees working in Patancheru's industrial zones. The service includes fixed routes, punctual pickups, and experienced chauffeurs, ensuring a smooth and consistent commuting experience for staff."
  },
  {
    "name": "Staff Pickup Drop Patancheru",
    "description": "Staff Pickup Drop Patancheru provides pre-scheduled transport for employees, ensuring timely pickups and drop-offs at workstations. The service is designed for companies with fixed shift patterns and includes GPS-enabled tracking, professional drivers, and optimized routes for maximum efficiency."
  }
],

"tableData": [
  ["Patancheru Industrial Cab", "Employee Shuttle Patancheru"],
  ["Business Cab Patancheru", "Affordable Cab Patancheru"],
  ["Monthly Corporate Cab Patancheru", "Best Corporate Cab Patancheru"],
  ["Outstation Cab Patancheru", "Sedan Cab Patancheru"],
  ["SUV Cab Patancheru", "Company Fleet Patancheru"],
  ["Factory Worker Cab Patancheru", "Office Transport Patancheru"],
  ["Corporate Shuttle Patancheru", "Employee Commute Patancheru"],
  ["Staff Pickup Drop Patancheru", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Patancheru Hyderabad",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides dependable corporate cab services in Patancheru Hyderabad, ensuring smooth and efficient transportation for employees and business executives in the industrial and IT hubs."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs across Patancheru’s industrial areas and corporate offices, helping employees reach their workplaces and meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our skilled chauffeurs provide safe, courteous, and disciplined travel, ensuring a comfortable and secure commuting experience for corporate passengers."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable corporate travel in Patancheru."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible and tailored cab rental plans to meet the commuting needs of companies and employees in Patancheru Hyderabad."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are sanitized regularly and equipped with modern safety features, providing secure and hygienic rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking process and reliable coordination, making employee transport hassle-free."
  }
]

































  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in Patancheru, Hyderabad?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies and industries located in Patancheru, Hyderabad.',
  },
  {
    question: 'What types of corporate transportation services are available in Patancheru?',
    answer: 'We provide employee transportation, industrial shuttle services, corporate pickups and drops, airport transfers, and complete fleet management for corporate and industrial clients.',
  },
  {
    question: 'Do you support daily employee commute services in Patancheru?',
    answer: 'Yes, we offer structured daily commute services with optimized routes, timely pickups, and support for multi-shift operations.',
  },
  {
    question: 'How can companies book corporate cab services in Patancheru?',
    answer: 'Companies can book via our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in Patancheru?',
    answer: 'We offer hatchbacks, sedans, SUVs, Innova Crysta, tempo travellers, luxury cars, and electric cabs depending on corporate requirements.',
  },
  {
    question: 'Do you provide long-term corporate cab contracts in Patancheru?',
    answer: 'Yes, we provide monthly, quarterly, and annual corporate transportation contracts with flexible pricing and complete fleet management.',
  },
  {
    question: 'Are your vehicles equipped with GPS and safety features?',
    answer: 'All vehicles are GPS-enabled, regularly sanitized, and driven by trained and background-verified chauffeurs for maximum safety.',
  },
  {
    question: 'Do you support night shift and rotational shift employee transport?',
    answer: 'Absolutely. We offer safe and timely transportation for night shifts, early morning shifts, weekend operations, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide consolidated monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Raghavendra Rao',
    feedback: 'Reliable corporate cab service for our Patancheru office. Drivers are punctual and vehicles are always clean and well-maintained.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Prasad',
    feedback: 'Professional and efficient transportation partner. Our employees are satisfied with the daily commute services provided.',
    rating: 5,
  },
];










































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Patancheru Hyderabad",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-patancheru.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited provides dedicated corporate cab services in Patancheru Hyderabad, including industrial transportation, employee shuttles, factory worker cabs, business cab services, monthly corporate cab rentals, staff pickup & drop, and outstation cab services for companies in the Patancheru industrial area.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-service-patancheru-hyderabad"
  }
};







  return (
    <div>
<Helmet>
  <title>Corporate Cab Service in Patancheru Hyderabad | Industrial & Employee Transport</title>

  <meta
    name="description"
    content="Corporate cab services in Patancheru Hyderabad covering industrial transport, employee shuttle, factory worker pickup & drop, office cabs, business travel, monthly corporate cab rentals, and affordable outstation cabs."
  />

  <meta
    name="keywords"
    content="Patancheru Industrial Cab, Employee Shuttle Patancheru, Business Cab Patancheru, Affordable Cab Patancheru, Monthly Corporate Cab Patancheru, Best Corporate Cab Patancheru, Outstation Cab Patancheru, Sedan Cab Patancheru, SUV Cab Patancheru, Company Fleet Patancheru, Factory Worker Cab Patancheru, Office Transport Patancheru, Corporate Shuttle Patancheru, Employee Commute Patancheru, Staff Pickup Drop Patancheru"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/81.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinpatancheru;